import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 * Component that displays either a cross or a check mark to indicate validity.
 *
 * @props **showValidation** - a function of type ``(field: FormlyFieldConfig) => boolean``
 * that can be used to override the check mark display condition.
 *
 */
@Component({
  selector: 'ish-validation-icons',
  templateUrl: './validation-icons.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [FaIconComponent],
})
export class ValidationIconsComponent {
  readonly field = input.required<FormlyFieldConfig>();
  readonly showError = input<boolean>(undefined);

  defaultShowValidation() {
    const field = this.field();
    return field.formControl?.valid && (field.formControl?.dirty || field.options?.parentForm?.submitted);
  }
}
